import { getSearchStringForBackNavigationWithBackText, nullSafeGetOrElse } from './DataAccessUtils';
import { HOME_PAGE_URLS, ROLE_TYPES } from './DataConstants';
import { getWorkOrderArchivalKey } from './WorkOrderUtils';

const queryString = require('qs');

export const getLocationSearch = (location) => {
	const searchString = location.search;
	return searchString[0] === '?' ? searchString.slice(1) : searchString;
};

export const generateBackLink = (url, location: any = {}): string => {
	const queryParams = queryString.parse(getLocationSearch(location));
	return `${url}?${queryParams.backlinkParams || ''}`;
};

export const isHomePageUrl = (url) => {
	const isHomPage = HOME_PAGE_URLS.filter((_) => url.includes(_)).length > 0;
	return isHomPage;
};

export const getDefaultWorkOrderTab = (currentUser, filters) => {
	const key = getWorkOrderArchivalKey(currentUser);
	return Object.keys(filters || {}).includes(key) ? (filters[key] ? 'archived' : 'active') : 'all';
};

export const getBackLinkStates = (location, defaultPath) => {
	const queryParams = queryString.parse(getLocationSearch(location));
	if (queryParams.backlinkParams) {
		const { pathName, backLinkText, targetCollectionName, ...otherParams } = queryString.parse(
			queryParams.backlinkParams
		);
		const finalPath = pathName || defaultPath;
		return {
			backLinkParams: new URLSearchParams(queryParams).toString(),
			backLinkTo: `${finalPath}?${new URLSearchParams(otherParams).toString()}`,
			...(backLinkText && { backLinkText }),
			fromTargetCollectionName: targetCollectionName || null,
		};
	}
	return {};
};

//Take current params and wrap them in a backlink (+1 level)
export const getLinkWIthBackLinkParams = (location, text, path, extraParams?) => {
	const searchString = getSearchStringForBackNavigationWithBackText(text, location, extraParams);
	return searchString && searchString.length > 0
		? path.includes('?')
			? path.concat(`&backlinkParams=${encodeURIComponent(searchString)}`)
			: path.concat(`?backlinkParams=${encodeURIComponent(searchString)}`)
		: path;
};

//Take backlink params and move them to current params (-1 level)
export const goBackLink = (location, defaultPath) => {
	const queryParams = queryString.parse(getLocationSearch(location));

	if (queryParams.backlinkParams) {
		const pathName = nullSafeGetOrElse(
			'pathName',
			queryString.parse(queryParams.backlinkParams),
			defaultPath
		);
		return `${pathName}?${queryParams.backlinkParams}`;
	}
	return defaultPath;
};

export const goBack = (location, history, defaultUrlPath) => {
	const string = goBackLink(location, defaultUrlPath);
	const [path, queryParams] = string.split('?');
	const urlSearchParams = queryString.parse(queryParams);
	history.replace(`${path}?${recursiveRemovePreserve(urlSearchParams)}`);
};

export const getQueryStringFromObject = (params) => {
	const string = Object.keys(params || {}).reduce((str, key, idx) => {
		if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
			return str + `${idx === 0 ? '' : '&'}${key}=${encodeURIComponent(params[key])}`;
		} else return str + '';
	}, '');
	return string;
};

export const openInNewTab = (link) => window.open(link, '_blank', 'noreferrer');

export const recursiveRemovePreserve = (urlSearchParams) => {
	if (urlSearchParams.backlinkParams) {
		const backSearchParams = queryString.parse(urlSearchParams.backlinkParams);
		const backlinkParams = new URLSearchParams(recursiveRemovePreserve(backSearchParams));
		const allParams = new URLSearchParams(urlSearchParams);
		allParams.set('backlinkParams', backlinkParams.toString());
		return allParams.toString();
	} else if (urlSearchParams.preserve) {
		let params = new URLSearchParams(urlSearchParams);
		params.delete('preserve');
		return params.toString();
	}
	return new URLSearchParams(urlSearchParams).toString();
};

/**
 * Safely encodes a value for use in a URL path segment.
 * Handles the case where the value may already be partially encoded
 * (e.g., from React Router v5 params which preserve percent-encoded reserved chars).
 * First decodes to normalize, then re-encodes cleanly.
 */
export const safeEncodeURIComponent = (value: string): string => {
	let decoded = value;
	try {
		decoded = decodeURIComponent(value);
	} catch (_) {
		// Invalid percent-encoding — fall back to the raw value
	}
	return encodeURIComponent(decoded);
};

export const getUserTypeFromURL = (location) => {
	const buyerInUrl = location.pathname.indexOf(ROLE_TYPES.BUYER) >= 0;
	const supplierInUrl = location.pathname.indexOf(ROLE_TYPES.SUPPLIER) >= 0;
	return buyerInUrl ? ROLE_TYPES.BUYER : supplierInUrl ? ROLE_TYPES.SUPPLIER : '';
};

// This function is used to get the history state for the same parent page only.
// only to be used in a hisotry.push. for <Link use OWLink with sameParent prop
export const getHistoryStateforSameParent = (location, to) => {
	const queryParams = new URLSearchParams(location.search);
	return {
		pathname: to,
		search: queryParams.toString(),
	};
};
